import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themeCache: {
      get: (key) => localStorage.getItem(key),
      set: (key, value) => localStorage.setItem(key, value),
    },
    themes: {
      light: {
        primary: "#6cadd8",
        secondary: "#8491d3",
        tertiary: "#ffffff",
        quinary: "#F8F8F8",
        accent: "#FC5130",
        background: "#f0f0f0",
      },
      dark: {
        primary: "#6cadd8",
        secondary: "#8491d3",
        accent: "#FF0000",
        background: "#333333",
        tertiary: "#1e1e1e",
        quaternary: "#707070",
        quinary: "#3f3f3f",
      },
    },
  },
});
